import React from "react";
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Box } from "@material-ui/core";

export default function DataTable({ columns, rows, maxHeight }){
  return (
    <Paper style={{borderRadius:14, overflow:"hidden"}}>
      <Box style={{maxHeight: maxHeight || 420, overflow:"auto"}}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map(c=>(
                <TableCell key={c.key} style={{fontWeight:800}}>
                  {c.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {(rows||[]).map((r,idx)=>(
              <TableRow key={r.id || idx} hover>
                {columns.map(c=>(
                  <TableCell key={c.key}>
                    {c.render ? c.render(r) : r[c.key]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Paper>
  );
}
